import { Data, DataComments } from '@root/modules/article/types/article';

export default function isArticleMultipage(article: Data | DataComments) {
  return article.settings.pageBreaksCount !== undefined;
}
